import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    rtnState:false
  },
  getters: {
  },
  mutations: {
    changeStatusFnc(state){
      state.rtnState=true;
    }
  },
  actions: {
  },
  modules: {
  }
})
